import { GET_MESH_DATA, SET_MESH_DATA } from "../constants/meshdata-constants";

export const getMeshData = () => ({
  type: GET_MESH_DATA,
});

export const setMeshData = (data) => ({
  type: SET_MESH_DATA,
  data,
});
